<template>
  <div><yonghugl /></div>
</template>

<script>
// 获取接口地址
import yonghugl from '@/components/yonghugl/yhgl'

export default {
  name: 'Yhgl',
  components: {
    // sideMenu,
    // Header
    yonghugl
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
